/* eslint-disable jsx-a11y/anchor-is-valid */
import { Input } from "../../../components/core/Input";
import Select from "../../../components/others/Select/Select";
import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import StyledWrapper from "./style";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import LavorisService from "../../../services/LavorisService";
import { InputEmail } from "../../../components/others/InputEmail";
import { DatePicker } from "../../../components/others/DatePicker/index";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { maritalStatuses, nationalities, sexs } from "../../../utils/dataOptionsUsers";
import { PhoneNumber } from "../../../components/others/PhoneNumber";
import moment from "moment";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import CuilRadioInput from "../../../components/others/CuilRadioInput/CuilRadioInput";
import InputCuil from "../../../components/others/InputCuil/InputCuil";
import DocumentRadioInput from "../../../components/others/DocumentRadioInput/DocumentRadioInput";

type TProps = {
  onClose: Function;
  refreshFunction: Function;
}

export default function AddApplicant({ onClose, refreshFunction }: TProps) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch
  } = useForm({
    mode: "all",
  });

  // Storage
  const { currentCompany, companies } = useSelector((state: RootState) => state.user)
  const { showAlert } = useAlert()
  const [data, setData] = useState<any>();
  const [apiErrors, setSetApiErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams("");
  const LavorisInstance = LavorisService.getInstance();
  const cuil = watch("cuil") || " ";
  const [hasCuil, setHasCuil] = useState(true);
  const [dni, setDni] = useState("");
  const dniValue = cuil.replace(/[^0-9]/g, "").substring(2, 10);
  const [documentType, setDocumentType] = useState("DNI");

  useEffect(() => {
    setDni(dniValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuil]);

  //GET ALL APPLICANTS FOR A COMPANY API CALL
  const getAllApplicantsCall = async () => {
    try {
      const applicants =
        await LavorisInstance.CompanyServices.getCandidatesOfCurrentCompany(currentCompany ? currentCompany.id : companies[0].id)
      if (applicants) {

        //  setTableLoading(false);
        setData(applicants);
        return applicants;
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const DNIsApplicants = (data && data.map((dni: any) => (dni.DNI)))

  const onSubmit = async (data: any) => {

    if (DNIsApplicants && DNIsApplicants.includes(data.DNI)) {
      return showAlert(`Ya existe un Postulante con el DNI: "${data.DNI}"`)
    }

    setIsLoading(true)
    const company = currentCompany ? currentCompany.id : companies[0].id
    const mappedData = {
      ...data,
      name: `${data.lastName}, ${data.name}`,
      DNI: data.DNI.trim().length === 0 ? dni : data.DNI,
      cuil:
        data.cuil === undefined || data.cuil === "" ? "Pendiente" : data.cuil,
      company: company,
      nationality: data.nationality !== "OTRO" ?
        data.nationality : data.nationalityOther,
      position: "OTROS",
      positionName: data?.positionName,
      //birthDate: moment(data?.birthDate).format("DD/DD/YYYY")
    }

    try {
      setSetApiErrors(false);
      const response = await LavorisInstance.CompanyServices.addApplicant(mappedData);
      if (response.message === "Success created") {
        onClose();
        refreshFunction();
      }
    } catch (err: any) {
      console.log(err);
      if (err.response.data.statusCode == 400) setSetApiErrors(true);
      showAlert(getErrorMessage({ title: 'Error al crear el candidato', err }));
    }
    finally {
      setIsLoading(false)
    }

  };

  const currentNationality = watch("nationality") || ""



  useEffect(() => {
    reset();
    getAllApplicantsCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>
          <Input
            type="text"
            label="Apellido"
            fieldName="lastName"
            register={register}
            required
            error={errors?.lastName}
          />
          <Input
            type="text"
            label="Nombre"
            fieldName="name"
            register={register}
            required
            error={errors?.name}
          />
          <CuilRadioInput hasCuil={hasCuil} setHasCuil={setHasCuil} />
          {hasCuil ? (
            <>
              <InputCuil
                label="CUIL -Sin espacios ni guiones-"
                fieldName="cuil"
                register={register}
                error={errors?.cuil}
                required={hasCuil}
                readOnly={!hasCuil}
              />
              <Input
                type="text"
                label="DNI"
                fieldName="DNI"
                register={register}
                error={errors?.DNI}
                readOnly={true}
                value={dni}
              />
            </>
          ) : (
              <>
                <DocumentRadioInput
                  documentType={documentType}
                  setDocumentType={setDocumentType}
                />
                {documentType === "DNI" ? (
                  <Input
                    type="text"
                    label="DNI"
                    fieldName="DNI"
                    register={register}
                    error={errors?.DNI}
                    required
                    pattern="^[0-9]*$" // Solo números para DNI
                  />
                ) : (
                  <Input
                    type="text"
                    label="Pasaporte"
                    fieldName="DNI"
                    register={register}
                    error={errors?.DNI}
                    required
                    pattern="^[a-zA-Z0-9]*$" // Números y letras para Pasaporte
                  />
                )}
              </>
          )}

          <DatePicker
            fieldName="birthDate"
            label={"Fecha de Nacimiento"}
            minDate={100}
            maxDate={18}
            defaultAvailableDate={null}
            control={control}
            required
            error={errors?.birthDate}
          />
          <Select
            fieldName="nationality"
            label="Nacionalidad"
            options={nationalities}
            register={register}
            error={errors?.nationality}
            required
            styles="rounded w-full h-[50px]"
          />
          {currentNationality === "OTRO" &&
            <>
              <p>Si su nacionalidad no se encuentra entre las opciones, por favor ingresela*</p>
              <Input
                type="text"
                fieldName="nationalityOther"
                label="Nacionalidad"
                register={register}
                error={errors?.position}
                required
              />
            </>
          }
          <Select
            fieldName="sex"
            label="Sexo"
            options={sexs}
            register={register}
            error={errors?.sex}
            required
            styles="rounded w-full h-[50px]"
          />
          <Input
            type="text"
            label="Género"
            fieldName="gender"
            register={register}
            required
            error={errors?.gender}
          />
          <Select
            fieldName="maritalStatus"
            label="Estado Civil"
            options={maritalStatuses}
            register={register}
            error={errors?.maritalStatus}
            required
            styles="rounded w-full h-[50px]"
          />
          <Input
            type="text"
            label="Puesto"
            fieldName="positionName"
            register={register}
            required
            error={errors?.positionName}
          />
          {/* <Select
            fieldName="position"
            label="Puesto"
            options={jobPositions}
            register={register}
            error={errors?.position}
            required
            styles="rounded w-full h-[50px]"
          /> */}
          <InputEmail
            label="E-mail"
            nameInput={"email"}
            register={register}
            error={errors}
            required
          />
          <span className="font-normal text-[13px] text-red-500">
            *A este e-mail le llegará para CONFIRMAR TURNO, completar la DECLARACIÓN JURADA obligatoria e indicaciones de presentación según práctica.
          </span>
          <PhoneNumber
            control={control}
            fieldName="phoneNumber"
            label="Teléfono"
            error={errors?.phoneNumber}
            required
          />
          <span className="font-normal text-[13px] text-red-500">
            *A este número le llegará la notificación de la fecha y hora del turno.
          </span>
        </StyledWrapper.FormContainer>
        <div className="w-full">
          <div className="w-full flex justify-end">
            <PrimaryButton
              type="submit"
              text="Cargar postulante"
              styles="bg-red-500 font-bold text-white w-1/3"
              disabled={isLoading}
            />
          </div>
          {apiErrors ? (
            <h1 className="text-center font-bold text-red-500 mt-1.5">
              Datos incorrectos
            </h1>
          ) : null}
        </div>
      </form>
    </>
  );
}
